import { UNKNOWN_ERROR } from 'utils/errors';
import { config } from 'api';

import {
  buildAccountSettingsNavigationLinks,
  buildStartShoppingNavigationLinks,
  buildYourAccountNavigationLinks,
} from 'apps/topNavigation/services/navigationLinksBuilder';

const url = `${config.apiBasePath}/navigation`;

export const REQUEST_TOP_NAVIGATION = 'REQUEST_TOP_NAVIGATION';
export const RECEIVE_TOP_NAVIGATION = 'RECEIVE_TOP_NAVIGATION';
export const RECEIVE_TOP_NAVIGATION_ERROR = 'RECEIVE_TOP_NAVIGATION_ERROR';
export const OPEN_MOBILE_NAV = 'OPEN_MOBILE_NAV';
export const CLOSE_MOBILE_NAV = 'CLOSE_MOBILE_NAV';
export const SET_MOBILE_NAV_LEVEL = 'MOBILE_NAV_LEVEL';
export const UPDATE_LINKS = 'UPDATE_LINKS';

export function openMobileNav(currentUrl) {
  return {
    type: OPEN_MOBILE_NAV,
    currentUrl,
  };
}

export function closeMobileNav() {
  return { type: CLOSE_MOBILE_NAV };
}

export function setMobileNavLevel(level) {
  return {
    type: SET_MOBILE_NAV_LEVEL,
    level,
  };
}

export function requestTopNavigation() {
  return { type: REQUEST_TOP_NAVIGATION };
}

export function receiveTopNavigation(topNavigation) {
  return {
    type: RECEIVE_TOP_NAVIGATION,
    topNavigation,
  };
}

export function receiveTopNavigationError(json) {
  return {
    type: RECEIVE_TOP_NAVIGATION_ERROR,
    error: json.error,
  };
}

export function fetchTopNavigation() {
  return (dispatch, getState, { network }) => {
    dispatch(requestTopNavigation());
    return network.get(url)
      .then((data) => {
        const { user, externalisedStrings = {} } = getState();
        dispatch(receiveTopNavigation(data));
        dispatch(updateLinks(user, data, externalisedStrings));
      })
      .catch(err => {
        dispatch(receiveTopNavigationError(err.data || UNKNOWN_ERROR));
      });
  };
}

export function updateLinks(user, topNavigation, externalisedStrings = {}) {
  return {
    type: UPDATE_LINKS,
    links: {
      account: buildYourAccountNavigationLinks(user, topNavigation),
      accountSettings: buildAccountSettingsNavigationLinks(user),
      startShopping: buildStartShoppingNavigationLinks(user, externalisedStrings),
      corporate: config.mobileNavigation.corporateLinks,
    },
  };
}

export function computeNavigationLinks() {
  return (dispatch, getState) => {
    const { user, topNavigation, externalisedStrings = {} } = getState();
    return dispatch(updateLinks(user, topNavigation, externalisedStrings));
  };
}
